import { render } from "./FolderAccessModal.vue?vue&type=template&id=66d760f4&scoped=true"
import script from "./FolderAccessModal.vue?vue&type=script&lang=js"
export * from "./FolderAccessModal.vue?vue&type=script&lang=js"

import "./FolderAccessModal.vue?vue&type=style&index=0&id=66d760f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d760f4"]])

export default __exports__